/** A state/year combination and whether users may pick it (from POST system-settings/get). */
export interface CalcVersionAvailability {
    stateCode: string;
    year: number;
    isEnabled: boolean;
}

/** One calc_version_availability row as the admin Calculations tab sees it. */
export interface AdminCalcVersionItem extends CalcVersionAvailability {
    /** False when the row names a combination that this build has no calcs for. */
    isBuilt: boolean;
    updatedAt?: string | null;
    updatedByName?: string | null;
}

/** POST admin/calc-versions/get. */
export interface AdminCalcVersionsResponse {
    versions: AdminCalcVersionItem[];
    /** Built combinations with no DB row (a migration is missing). */
    missingRows: { stateCode: string; year: number }[];
}

/** 403 body code for a write refused because the case's state/year is not enabled. */
export const CALC_VERSION_DISABLED_CODE = 'CalcVersionDisabled';
